export const sports = [
  'Football',
  'Basketball',
  'Tennis',
  'Baseball',
]

export const demoEvents = [
  {
    id: 'HC123',
    homeTeam: 'Team A',
    awayTeam: 'Team B',
    start: '2024-04-25 18:00',
    odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB456',
    homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
    odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Upcoming',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HC759',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
     odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB012',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-25 18:00',
     odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HC345',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-25 18:00',
     odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB678',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
    odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB679',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
    odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB680',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
    odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB681',
    homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
     odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB682',
     homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
   odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
  {
    id: 'HB683',
    homeTeam: 'Team C',
    awayTeam: 'Team D',
    start: '2024-04-26 18:00',
    odds: { "home" : 2.10, "away": 3.20, "homeHandicap": "+2.5,+3.0", "awayHandicap": "-2.5,-3.0" },
    goalOdds: { "over" : 1.80, "under" : 2.50, "overHandicap" : "+3.5","underHandicap" : "-3.5" },
    isHomeOdds: true,
    myanOdds: ["1+30", "4-20"],
    status: 'Live',
    leagueName: 'Premier League',
    sport: 'Football',
  },
]

export const demoNotifications = [
  {
    type: 'warning',
    title: 'Odds movement alert',
    message: 'Odds for Team A vs Team B have changed from 2.10 to 2.20',
  },
  {
    type: 'danger',
    title: 'Over-exposure alert',
    message: 'Exposure for Team C vs Team D is above the allowed limit',
  },
]


export const detailsVoucherList = [
  {
    gamblingId: 'HC123',
    vouchers: [
      { id: 'VCH-001', name: 'Matchday Booster', user: 'alex.d', amount: 250, type: 'Single', status: 'Active' },
      { id: 'VCH-002', name: 'Late Goal Edge', user: 'mia.koprtyuui', amount: 180, type: 'Parlay', status: 'Pending' },
      { id: 'VCH-003', name: 'Home Advantage', user: 'liam.p', amount: 320, type: 'Single', status: 'Settled' },
    ],
  },
  {
    gamblingId: 'HB456',
    vouchers: [
      { id: 'VCH-010', name: 'Court Kings Combo', user: 'rhea.s', amount: 140, type: 'Parlay', status: 'Active' },
      { id: 'VCH-011', name: 'Fourth Quarter Push', user: 'noah.m', amount: 95, type: 'Single', status: 'Pending' },
      { id: 'VCH-012', name: 'Underdog Lift', user: 'sofia.r', amount: 210, type: 'Teaser', status: 'Active' },
    ],
  },
  {
    gamblingId: 'HC759',
    vouchers: [
      { id: 'VCH-020', name: 'Night Match Surge', user: 'oliver.t', amount: 300, type: 'Single', status: 'Active' },
      { id: 'VCH-021', name: 'Sharp Shooter Parlay', user: 'emma.l', amount: 175, type: 'Parlay', status: 'Pending' },
      { id: 'VCH-022', name: 'Clean Sheet Shield', user: 'lucas.v', amount: 210, type: 'Single', status: 'Settled' },
    ],
  },
  {
    gamblingId: 'HB012',
    vouchers: [
      { id: 'VCH-030', name: 'Early Bird Edge', user: 'nina.c', amount: 260, type: 'Single', status: 'Active' },
      { id: 'VCH-031', name: 'Halftime Momentum', user: 'ethan.a', amount: 135, type: 'Parlay', status: 'Active' },
      { id: 'VCH-032', name: 'Goal Line Guard', user: 'ava.w', amount: 190, type: 'Single', status: 'Settled' },
    ],
  },
  {
    gamblingId: 'HC345',
    vouchers: [
      { id: 'VCH-040', name: 'Derby Day Double', user: 'jack.h', amount: 285, type: 'Parlay', status: 'Active' },
      { id: 'VCH-041', name: 'Keeper Cleanse', user: 'amelia.f', amount: 160, type: 'Single', status: 'Pending' },
      { id: 'VCH-042', name: 'Last-Minute Lift', user: 'will.g', amount: 220, type: 'Single', status: 'Active' },
    ],
  },
  {
    gamblingId: 'HB678',
    vouchers: [
      { id: 'VCH-050', name: 'High Stakes Combo', user: 'ivy.s', amount: 320, type: 'Parlay', status: 'Active' },
      { id: 'VCH-051', name: 'Away Run Cover', user: 'kai.n', amount: 145, type: 'Single', status: 'Pending' },
      { id: 'VCH-052', name: 'Goal Rush Boost', user: 'zoe.b', amount: 205, type: 'Single', status: 'Active' },
    ],
  },
  {
    gamblingId: 'HB679',
    vouchers: [
      { id: 'VCH-060', name: 'Midfield Maestro', user: 'lola.d', amount: 275, type: 'Single', status: 'Active' },
      { id: 'VCH-061', name: 'Late Flip Parlay', user: 'mason.q', amount: 165, type: 'Parlay', status: 'Pending' },
      { id: 'VCH-062', name: 'Defence Wall', user: 'ruby.e', amount: 195, type: 'Teaser', status: 'Active' },
    ],
  },
  {
    gamblingId: 'HB680',
    vouchers: [
      { id: 'VCH-070', name: 'Clean Sheet Parlay', user: 'henry.j', amount: 240, type: 'Parlay', status: 'Active' },
      { id: 'VCH-071', name: 'High-Press Push', user: 'ella.c', amount: 155, type: 'Single', status: 'Settled' },
      { id: 'VCH-072', name: 'Precision Play', user: 'adam.t', amount: 210, type: 'Single', status: 'Pending' },
    ],
  },
  {
    gamblingId: 'HB681',
    vouchers: [
      { id: 'VCH-080', name: 'First Goal Flash', user: 'ivy.s', amount: 285, type: 'Single', status: 'Active' },
      { id: 'VCH-081', name: 'Momentum Builder', user: 'jude.v', amount: 170, type: 'Parlay', status: 'Active' },
      { id: 'VCH-082', name: 'Counter Cover', user: 'nora.p', amount: 195, type: 'Single', status: 'Settled' },
    ],
  },
  {
    gamblingId: 'HB682',
    vouchers: [
      { id: 'VCH-090', name: 'Prime Time Pulse', user: 'aria.k', amount: 305, type: 'Single', status: 'Active' },
      { id: 'VCH-091', name: 'Full Time Flow', user: 'owen.l', amount: 165, type: 'Parlay', status: 'Pending' },
      { id: 'VCH-092', name: 'Goal Line Lift', user: 'ivy.s', amount: 200, type: 'Single', status: 'Active' },
    ],
  },
  {
    gamblingId: 'HB683',
    vouchers: [
      { id: 'VCH-100', name: 'Momentum Chain', user: 'sara.h', amount: 295, type: 'Parlay', status: 'Active' },
      { id: 'VCH-101', name: 'On Target Boost', user: 'ryan.p', amount: 180, type: 'Single', status: 'Pending' },
      { id: 'VCH-102', name: 'Pitch Control', user: 'mila.g', amount: 215, type: 'Teaser', status: 'Settled' },
    ],
  },
]
